import LegislativnyMaterialCreatePage from './LegislativnyMaterialCreatePage';

export default LegislativnyMaterialCreatePage;
